import { useError } from '../../contexts/ErrorContext';
import BasicModal from './BasicModal';
import { useState, useEffect } from 'react';
import {
  ExclamationTriangleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';

const ERROR_CONFIGS = {
  error: {
    icon: ExclamationCircleIcon,
    iconBackground: 'bg-red-100',
    iconColor: 'text-red-600',
  },
  warning: {
    icon: ExclamationTriangleIcon,
    iconBackground: 'bg-yellow-100',
    iconColor: 'text-yellow-600',
  },
  info: {
    icon: InformationCircleIcon,
    iconBackground: 'bg-blue-100',
    iconColor: 'text-blue-600',
  },
};

export default function ErrorModal() {
  const { errorState = null, hideError } = useError();
  const { title, message, type } = errorState || {};
  const [isClosing, setIsClosing] = useState(false);

  const config = ERROR_CONFIGS[type] || ERROR_CONFIGS.error;
  const IconComponent = config.icon;

  // Reset closing state when error state changes
  useEffect(() => {
    if (errorState) {
      setIsClosing(false);
    }
  }, [errorState]);

  const handleClose = () => {
    setIsClosing(true);
    // Delay clearing the error state to match the modal's closing animation (200ms)
    setTimeout(() => {
      hideError();
    }, 200);
  };

  return (
    <BasicModal
      showModal={errorState !== null && errorState !== undefined && !isClosing}
      setShowModal={handleClose}
      title={title}
      icon={<IconComponent className={`h-6 w-6 ${config.iconColor}`} aria-hidden='true' />}
      iconBackground={config.iconBackground}
      maxWidth='sm:max-w-lg'>
      <div className='mt-2 text-center'>
        <div className='text-sm text-gray-500'>{message}</div>
      </div>
      <div className='mt-5 sm:mt-6'>
        <button
          type='button'
          className='inline-flex w-full w-48 justify-center rounded-md bg-emerald-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600'
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleClose();
          }}>
          Close
        </button>
      </div>
    </BasicModal>
  );
}
